import { importFromXlsx } from '@/shared/utils/xlsxExport';

/** 수기 의약품 대량 등록 XLSX 헤더 (레거시 insertDrugsManual 필드) */
export const DRUG_BULK_UPLOAD_HEADER_MAP: Record<string, string> = {
  refYm: '기준년월*',
  drugCode: '의약품 코드*',
  drugCodePharma: '제약사 의약품 코드',
  drugCodeMfds: '표준코드(MFDS)',
  drugName: '의약품명*',
  unitQuantity: '규격',
  baseUnit: '단위',
  reimbursementType: '급여 구분',
  etcOtcType: '전문/일반',
  dataSourceType: '데이터 출처',
  administrationRouteType: '투여 경로',
  atcCode: 'ATC 코드',
};

export const downloadDrugBulkUploadTemplate = async () => {
  const { exportXlsxTemplate } = await import('@/shared/utils/xlsxExport');
  exportXlsxTemplate(DRUG_BULK_UPLOAD_HEADER_MAP, '의약품_수기등록_양식');
};

const trimOrUndefined = (value: unknown): string | undefined => {
  if (value == null) return undefined;
  const text = String(value).trim();
  return text || undefined;
};

export const mapBulkUploadRowToInsertItem = (
  row: Record<string, unknown>,
): Record<string, unknown> => ({
  refYm: trimOrUndefined(row.refYm),
  drugCode: trimOrUndefined(row.drugCode),
  drugCodePharma: trimOrUndefined(row.drugCodePharma),
  drugCodeMfds: trimOrUndefined(row.drugCodeMfds),
  drugName: trimOrUndefined(row.drugName),
  unitQuantity: trimOrUndefined(row.unitQuantity),
  baseUnit: trimOrUndefined(row.baseUnit),
  reimbursementType: trimOrUndefined(row.reimbursementType) ?? '비급여',
  etcOtcType: trimOrUndefined(row.etcOtcType) ?? '일반',
  dataSourceType: trimOrUndefined(row.dataSourceType) ?? 'ADMIN',
  administrationRouteType: trimOrUndefined(row.administrationRouteType),
  atcCode: trimOrUndefined(row.atcCode),
});

export const parseDrugBulkUploadFile = async (file: File) => {
  const rows = await importFromXlsx(file, DRUG_BULK_UPLOAD_HEADER_MAP, {
    validateOnlyRequiredHeaders: true,
  });
  return rows.map(mapBulkUploadRowToInsertItem);
};

export const chunkArray = <T,>(items: T[], size: number): T[][] => {
  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
};
